module.exports = __webpack_public_path__ + "static/media/bell-curve-shadow.7e4b7cc9.svg";